module.exports = __webpack_public_path__ + "news_01.png?9f35392e7f6977f0c519729f47530011";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lottery/news_01.png
// module id = 633
// module chunks = 0